export default __webpack_public_path__ + "static/media/university.abe1ac05.webp";